import * as React from 'react';

import { Route } from 'react-router';

import { Routes } from 'components/routes';
import { StoreInfoModalContainer } from 'components/store-info-modal';
import { relativeRoutes } from 'utils/routing';

export const StoreInfoRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={relativeRoutes.store}>
        {/* Store info requests data by id and/or storeNumber supplied depending on route. */}
        <Route path={':id'} element={<StoreInfoModalContainer />} />
        <Route path={':storeNumber'}>
          <Route path={'*'} element={<StoreInfoModalContainer />} />
        </Route>
      </Route>
    </Routes>
  );
};
